import React from 'react';

interface FunnelProgressProps {
  currentStep: number;
  totalSteps: number;
}

export const FunnelProgress: React.FC<FunnelProgressProps> = ({ currentStep, totalSteps }) => {
  if (totalSteps < 1) {
    return null;
  }

  const step = Math.min(Math.max(currentStep, 1), totalSteps);
  const percent = Math.round((step / totalSteps) * 100);

  return (
    <div>
      <div className="mb-2.5 flex items-baseline justify-between text-xs tracking-wide">
        <span className="font-bold uppercase text-bzblue-1000">
          Step {step} of {totalSteps}
        </span>
        <span className="font-semibold text-slate-500">{percent}% complete</span>
      </div>
      <div
        aria-label="Funnel progress"
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={percent}
        className="h-2 overflow-hidden rounded-full bg-bzblue-300"
        role="progressbar"
      >
        <div
          className="h-full min-w-[8px] rounded-full bg-emerald-400 transition-[width] duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};
